import React, { useState } from 'react'

const MovieImdb = props => {
  // props for this file from parent
  const { sendImdb, sendBooleanValueChangeDone, Imdb, movieMode, MovieYouSayRatingInput } = props
  // state variable for this file
  const [validRating, setValidRating] = useState(false)
  // function to handle change in imdb rating and send it to parent
  const handleImdb = event => {
    if (event.target.value >= 0) {
      const { value, maxLength } = event.target
      const message = value.slice(0, maxLength)
      sendImdb('imdb', message)
      sendBooleanValueChangeDone('movierating', true)
      if (movieMode === 'create') {
        if (message >= 1 && message <= 10) {
          setValidRating(false)
        } else {
          setValidRating(true)
        }
      } else if (event.target.value >= 10 && event.target.value <= 100) {
        setValidRating(false)
      } else {
        setValidRating(true)
      }
    }
  }

  const handleWheel = event => {
    event.target.blur()
    // Check if the target is an input of type number
    event.preventDefault()
    event.stopPropagation()
  }

  return (
    <div>
      <label>
        Imdb:<div className='mandatory'>*</div>
      </label>
      {movieMode === 'create' ? (
        <input
          type='number'
          className='form-control'
          style={{ width: '48%' }}
          // maxLength='1'
          max={9}
          min={0}
          maxLength='1'
          value={Imdb}
          onChange={event => handleImdb(event)}
          onWheel={handleWheel}
          // imdb input field is disabled if MovieYouSayRatingInput is not empty
          disabled={MovieYouSayRatingInput !== ''}
        />
      ) : (
        <input
          type='number'
          className='form-control'
          style={{ width: '48%' }}
          // maxLength='1'
          max={99}
          min={10}
          maxLength='2'
          value={Imdb}
          onWheel={handleWheel}
          onChange={event => handleImdb(event)}
          disabled={MovieYouSayRatingInput !== ''}
        />
      )}
      {/* if validRating is true then show the message */}
      {/* if movieYousayRatingInput is empty then show the message */}
      {MovieYouSayRatingInput ? null : movieMode === 'create' ? (
        <div>
          {validRating && <span className='mandatory1'>rating should be between 1 and 10</span>}
        </div>
      ) : (
        <div>
          {validRating && <span className='mandatory1'>rating should be between 10 and 100</span>}
        </div>
      )}
    </div>
  )
}

export default MovieImdb
